import { Injectable } from '@angular/core';
import {WindowService} from './window/window.service';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {environment} from '../../environments/environment';
import {Subject, Observable} from 'rxjs';
import {SpinnerService} from '../core/spinner/spinner.service';
import {NotificationBarService} from '../core/notify/notification.service';
import {NotificationType} from'../core/notify/index';
import {Router} from '@angular/router';
import {CookieService} from 'ng2-cookies';
import {WindowRef} from "../core/window.service";

@Injectable()
export class AuthService {
  private token = null;
  private authUrl: string;
  private logoutUrl: string;
  private profileURI = `${environment.serviceBase}/accounts/user/profile`;
  private windowHandle: any;
  private userProfile;
  private profileSubject: Subject<any> = new Subject();
  private online = false;

  constructor(
    private windowService: WindowService,
    private windowRef: WindowRef,
    private http: Http,
    private spinner: SpinnerService,
    private notifier: NotificationBarService,
    private router: Router,
    private cookie: CookieService
  ) {
    if (this.cookie.get('token')) {
      this.token = this.cookie.get('token');
    }
    if (this.cookie.get('userProfile')) {
      this.userProfile = JSON.parse(this.cookie.get('userProfile'));
      this.profileSubject.next(this.userProfile);
    }
  }

  setAuthUrl(oAuthOptions) {
   this.authUrl = `${oAuthOptions.site}${oAuthOptions.authPath}?client_id=${oAuthOptions.clientId}&redirect_uri=${oAuthOptions.redirectUri}&response_mode=fragment&response_type=id_token token&scope=${oAuthOptions.scope}
    &nonce=${this.genNonce()}`;
  }

  setLogoutUrl(site: string , sessionpath: string , redirectUri: string) {
    this.logoutUrl = `${site}${sessionpath}?id_token_hint=${this.cookie.get('id_token')}&post_logout_redirect_uri=${redirectUri}`;
  }

  openLoginWindow(otac?: string) {
    let otacParam;
    if (otac) {
      otacParam = `&otac=${otac}`;
      this.windowHandle = this.windowService.createWindow(`${this.authUrl}${otacParam}`);
      return;
    }
    this.windowHandle = this.windowService.createWindow(`${this.authUrl}`);

  }

  private  closeLoginWindow() {
    if (this.windowHandle && this.windowHandle.close) {
      this.windowHandle.close();
    }
  }

  private   genNonce() {
    const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
    const result = [];
    let crypto = this.windowRef.nativeWindow.crypto || this.windowRef.nativeWindow.msCrypto;
    if (crypto) {
      let randomValues = crypto.getRandomValues(new Uint8Array(32));
      for (let i = 0, limit = randomValues.length; i < limit ; i++ ) {
        result.push(charset[randomValues[i] % charset.length]);
      }
      return result.join('');
    }
    return charset;
  }

  getProfileSubject(): Observable<any> {
    return this.profileSubject.asObservable();
  }

  getUserProfile() {
    return this.userProfile ? this.userProfile : null;
  }

  getToken() {
    return this.cookie.get('token');
  }

  setUserProfileAfterUpdate(profile) {
    this.userProfile.name = profile.name;
    this.userProfile.organizationRole = profile.organizationRole;
    this.profileSubject.next(this.userProfile);
    this.cookie.set('userProfile', JSON.stringify(this.userProfile));
  }

  didFirstLogin() {
    let data = {
      operation: 'replace',
      path: 'firstLogin',
      value: false
    };
    let headers = new Headers({ 'Content-Type': 'application/json'});
    headers.append('Authorization', `Bearer ${this.token}`);
    let options = new  RequestOptions({headers: headers});
    return this.http.patch(`${environment.serviceBase}/users/${this.userProfile.id}`, data, options)
      .map(() => {
      this.userProfile.firstLogin = false;
      this.cookie.set('userProfile', JSON.stringify(this.userProfile));
      return true;
    })
      .catch(() => { return Observable.throw(false); });
  }

  setToken(token, idToken?: string) {
    this.cookie.set('token', token);
    if (idToken) {
      this.cookie.set('id_token', idToken);
    }
    this.token = token;

    this.setLogoutUrl(environment.auth.site, environment.auth.endSession,
      environment.auth.logoutUri);

  }
  isLoggedIn() {
    return !!this.getToken() && !!this.getUserProfile();
  }

  isUserProfileExist(): Observable<boolean> {
    this.spinner.show();
    if (!this.token) {
      this.spinner.hide();
      return Observable.of(false);
    }
    if (this.userProfile) {
      this.spinner.hide();
      return Observable.of(true);
    }
    if (this.token && !this.userProfile) {
      this.spinner.show();
      let headers = new Headers({ 'Content-Type': 'application/json'});
      headers.append('Authorization', `Bearer ${this.token}`);
      let options = new  RequestOptions({headers: headers});
      return this.http.get(this.profileURI, options)
        .map(this.extractData)
        .catch(this.handleError);
    }
  }

  getCurrentAccount(): any {
    return this.userProfile ? this.userProfile.account[0] : null ;
  }

  logout() {
   this.deleteAllAuthCookies();
    this.token = null;
    this.userProfile = null;
    this.windowService.createWindow(this.logoutUrl);
  }

  deleteOtac() {
    this.cookie.delete('otac', '/');
  }

  navigateToServerDownPage() {
    if (this.online) {
      this.router.navigate(['/server-not-available']);
    }
  }

  setTokenFromUrl(hash) {
    let splitted = hash.split('&');
    let params = {};

    for (let i = 0; i < splitted.length; i++) {
      let param  = splitted[i].split('='),
          key    = param[0],
          value  = param[1];
      params[key] = value;
    }

    if (params['access_token']) {
      this.setToken(params['access_token'], params['id_token'] );
    }

  }
  private extractData = (res: Response) => {
    this.spinner.hide();
    let body = res.json();
    this.cookie.set('userProfile', JSON.stringify(body.data));
    this.profileSubject.next(body.data);
    this.userProfile = body.data;
    return true;
  }

  private deleteAllAuthCookies() {
    this.cookie.delete('otac', '/');
    this.cookie.delete('userProfile', '/');
    this.cookie.delete('token', '/');
    this.cookie.delete('id_token', '/');
  }
  private handleError = (error: Response | any) => {
    this.spinner.hide();
    this.logout();
    this.deleteAllAuthCookies();
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      errMsg = body.status.message;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
     if (error.status !== 0) {
       this.notifier.create({message: errMsg,
         type: NotificationType.Error, autoHide: true});
     } else {
        this.navigateToServerDownPage();
     }
    return Observable.throw(false);
  }



}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts